<template>
  <v-container fluid>
    <main-header-plat-a />
    <main-header-plat-b :navBItems="schema.navBItems" />
    <v-overlay v-model="overlayCal" style="z-index: 1000; position: absolute">
      <v-row class="mt-n15 ml-10" style="width: 200px">
        <v-col cols="12" class="ma-0 pa-0">
          <span class="d-flex text-subtitle-1 justify-center text-black">Descargando</span>
        </v-col>
        <v-col cols="12">
          <v-progress-linear class="mx-auto" indeterminate rounded height="7"></v-progress-linear>
        </v-col>
      </v-row>
    </v-overlay>
    <v-row class="flex-nowrap">
      <div class="barLateral">
        <v-nav-draw-anam :anamIndex="anamIndex" :anamGroupShow="anamGroupShow" />
      </div>
      <div class="contentCentral">
        <v-card-form-anam :anamRoute="schema.anamRoute" />
        <v-card class="contentCardCentral secundary5 mx-2" flat>
          <v-row>
            <v-col xs="12" sm="12" md="12">
              <v-card-pro-test-result1
                :cardTest1Items="schema.cardTest1Items"
                :btnClicked="btnClicked"
                :coInfoResult="schema.coInfoResult"
              />
            </v-col>
          </v-row>
        </v-card>
      </div>
    </v-row>
    <v-overlay
      :value="overlay"
      @update:value="overlay = $event"
      class="d-flex align-star justify-center"
      style="z-index: 1000; position: absolute"
    >
      <v-row class="d-flex justify-center my-5">
        <v-card min-height="200" width="70%" class="secundary6">
          <v-card-title class="text-body-1 font-weight-bold justify-center">
            Aviso
          </v-card-title>
          <v-card-text class="text-body-2">
            {{ overlayMessage }}
          </v-card-text>
          <v-card-actions class="mx-auto mb-5">
            <v-btn
              color="primary"
              class="d-flex mx-auto justify-center"
              @click="toggleOverlay()"
            >
              IR A INDEX
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-row>
    </v-overlay>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import MainHeaderPlatA from '@/components/includes/MainHeaderPlatA.vue';
import MainHeaderPlatB from '@/components/includes/MainHeaderPlatB.vue';
import VNavDrawAnam from '@/components/base/VNavDrawAnam.vue';
import VCardFormAnam from '@/components/base/VCardFormAnam.vue';
import VCardProTestResult1 from '@/components/base/VCardProTestResult1.vue';

export default {
  name: 'CorrectorsPage',
  components: {
    MainHeaderPlatA,
    MainHeaderPlatB,
    VNavDrawAnam,
    VCardFormAnam,
    VCardProTestResult1,
  },
  data() {
    return {
      overlay: false,
      overlayMessage: '',
    };
  },
  mounted() {
    this.loadData();
  },
  computed: {
    ...mapGetters('testCOxResults', ['schema', 'coResults', 'overlayCal']),
    ...mapGetters('anamPermissions', ['anamIndex', 'anamGroupShow', 'hasPermission', 'observerHCP']),
  },
  methods: {
    ...mapActions('testCOxResults', ['loadSchema', 'toggleOverlayCal']),
    ...mapActions('anamPermissions', ['loadPermissionsHCP', 'sectionsHCPandRoute', 'checkPermission', 'loadObserverHCP']),

    async loadData() {
      await this.$store.dispatch('testCOxResults/toggleOverlayCal', true);
      try {
        await Promise.all([
          this.loadSchema(),
          this.sectionsHCPandRoute(this.$route),
        ]);

        if (!this.hasPermission) {
          this.overlay = true;
          this.overlayMessage = 'No tiene acceso a esta sección. Solicite permisos.';
          return;
        }
      } catch (error) {
        this.handleDataError(error, 'Error al cargar datos.');
      } finally {
        await this.$store.dispatch('testCOxResults/toggleOverlayCal', false);
      }
    },

    btnClicked() {
      let exportClicked = 1;
      this.$store.dispatch('testCOxResults/coResultDownload', {
        exportClicked,
      });
    },

    toggleOverlay() {
      this.overlay = !this.overlay;
      if (!this.overlay && this.$route.name !== 'index') {
        this.$router.replace({ name: 'index' });
      }
    },
  },
};
</script>

<style>
.barLateral {
  min-width: 60px;
}

.contentCentral {
  width: 96%;
}

.contentCardCentral {
  width: 98.5%;
  margin-top: 90px;
}

.contentRowCentral {
  width: 80%;
  min-height: 400px;
}

.bannerAction {
  width: 87%;
  height: 48px;
}
</style>
